import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showMessage } from "store/misc/messageSlice";
import authService from "../services/authService";
import storeService from "../services/storeService";
import settingsService from "admin/services/settingsService";

const initialState = {
	accessToken: null,
	isSubmitting: false,
	isSettingsLoaded: false,
	isSettingsLoading: false,
	isCorksyAccountConnected: false,
	settings: {},
};

export const getSettings = createAsyncThunk(
	"store/fetchSettings",
	async (_, { dispatch }) => {
		try {
			dispatch(setSettingsLoading(true));
			const settings = await settingsService.get();
			return settings;
		} catch (error) {
			console.error(error);
			dispatch(
				showMessage({
					variant: "error",
					message: "Error occurred while connecting corksy account",
				})
			);
		} finally {
			dispatch(setSettingsLoading(false));
		}
	}
);

export const connectStore = createAsyncThunk(
	"store/connect",
	async (login, { dispatch, rejectWithValue }) => {
		try {
			dispatch(setSubmitting(true));
			await authService.signInWithEmailAndPassword(login);
			const appKey = await storeService.connect();
			await await settingsService.save({ appKey });
			return appKey;
		} catch (error) {
			console.error(error);
			if (error.response) {
				const { status, data } = error.response;
				dispatch(loginError({ status, data }));
			}
			dispatch(
				showMessage({
					variant: "error",
					message: "Error occurred while connecting corksy account",
				})
			);
			return rejectWithValue(error);
		} finally {
			dispatch(setSubmitting(false));
		}
	}
);

const storeSlice = createSlice({
	name: "store",
	initialState,
	reducers: {
		setSubmitting: (state, action) => {
			state.isSubmitting = action.payload;
		},
		loginError: (state, action) => {
			state.error = action.payload;
		},
		setSettingsLoading: (state, action) => {
			state.isSettingsLoading = action.payload;
		},
	},
	extraReducers: {
		[connectStore.fulfilled]: (state, action) => {
			state.settings = {
				appKey: action.payload,
			};
			state.isCorksyAccountConnected = true;
		},

		[getSettings.fulfilled]: (state, action) => {
			const { app_key } = action.payload;
			state.settings = action.payload;
			state.isSettingsLoaded = true;
			state.isCorksyAccountConnected = !!app_key;
		},
	},
});

export const {
	setSubmitting,
	loginError,
	setSettingsLoading,
} = storeSlice.actions;

export default storeSlice.reducer;
